// extracted by mini-css-extract-plugin
export default {"logoWrapper":"FeatureLogos_logoWrapper__wnr3v","logo":"FeatureLogos_logo__2DU4W"};